import classname from "classnames";
import { MENU_CODE, returnImgByMenuCode } from "constants/layout";
import { checkIsHaveInvoicePos } from "helpers/utils";
import jwt_decode from "jwt-decode";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import {
  AUTH_TOKEN,
  ROLE_ACCOUNTANT,
  ROLE_ADMIN,
  ROLE_APP_ADMIN,
  ROLE_EINVOICE_ADMIN,
  ROLE_SUPERVISOR,
} from "store/auth/login/actionTypes";
import "./style.scss";

const menu = [
  //   {
  //     id: 34,
  //     menuName: "Thông báo từ TCT",
  //     menuCode: MENU_CODE.NOTICE_FROM_TCT.code,
  //     menuOrder: 10,
  //     parentId: null,
  //     sys: null,
  //     superAdmin: null,
  //     urlPropertyName: null,
  //     moduleName: "home",
  //     menuType: null,
  //     menuPublic: null,
  //     historyToken: "/notice-from-TCT",
  //     children: [],
  //   },

  {
    id: 34,
    menuName: "Hóa đơn",
    menuCode: MENU_CODE.ISSUE_VAT_INVOICE.code,
    menuOrder: 10,
    parentId: null,
    sys: null,
    superAdmin: null,
    urlPropertyName: null,
    moduleName: "home",
    menuType: null,
    menuPublic: null,
    historyToken: null,
    children: [
      {
        id: 35,
        menuName: "Lập hóa đơn",
        menuCode: "ROLE",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/invoice/create",
        children: [],
      },
      {
        id: 35,
        menuName: "Lưu tạm",
        menuCode: "ROLE",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/invoice/new",
        children: [],
      },
      {
        id: 35,
        menuName: "Đã phát hành",
        menuCode: "ROLE",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/invoice/release",
        children: [],
      },
      {
        id: 35,
        menuName: "Chờ phát hành",
        menuCode: "ROLE",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/invoice/wait-release",
        children: [],
      },
      {
        id: 35,
        menuName: "Hủy",
        menuCode: "ROLE",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/invoice/cancel",
        children: [],
      },
      {
        id: 35,
        menuName: "Thay thế",
        menuCode: "ROLE",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/invoice/replace",
        children: [],
      },
      {
        id: 35,
        menuName: "Điều chỉnh",
        menuCode: "ROLE",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/invoice/adjust",
        children: [],
      },
      {
        id: 35,
        menuName: "Tất cả",
        menuCode: "ROLE",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/invoice/all",
        children: [],
      },
      {
        id: 35,
        menuName: "Hóa đơn đã xuất",
        menuCode: "ROLE",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/invoice/report",
        children: [],
      },
      {
        id: 36,
        menuName: "Bảng kê hóa đơn thay thế /điều chỉnh",
        menuCode: "ROLE",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: null,
        children: [
          {
            id: 37,
            menuName: "Lập bảng kê hóa đơn thay thế /điều chỉnh",
            menuCode: "ROLE",
            menuOrder: 20,
            parentId: 36,
            sys: null,
            superAdmin: null,
            urlPropertyName: "ECONTRACT",
            moduleName: "home",
            menuType: null,
            menuPublic: null,
            historyToken: "/invoice-statements/create",
            children: [],
          },
          {
            id: 38,
            menuName: "Danh sách bảng kê thay thế /điều chỉnh",
            menuCode: "ROLE",
            menuOrder: 20,
            parentId: 36,
            sys: null,
            superAdmin: null,
            urlPropertyName: "ECONTRACT",
            moduleName: "home",
            menuType: null,
            menuPublic: null,
            historyToken: "/invoice-statements",
            children: [],
          },
        ],
      },
    ],
  },

  {
    id: 434,
    menuName: "Nghiệp vụ Hóa đơn",
    menuCode: MENU_CODE.INVOICE_SERVICE.code,
    menuOrder: 10,
    parentId: null,
    sys: null,
    superAdmin: null,
    urlPropertyName: null,
    moduleName: "home",
    menuType: null,
    menuPublic: null,
    historyToken: null,
    children: [
      {
        id: 40,
        menuName: "Hóa đơn sai sót",
        menuCode: MENU_CODE.ISSUE_SALES_INVOICE.code,
        menuOrder: 10,
        parentId: null,
        sys: null,
        superAdmin: null,
        urlPropertyName: null,
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: null,
        children: [
          {
            id: 41,
            menuName: "Lập thông báo hóa đơn sai sót",
            menuCode: "ROLE",
            menuOrder: 20,
            parentId: 34,
            sys: null,
            superAdmin: null,
            urlPropertyName: "ECONTRACT",
            moduleName: "home",
            menuType: null,
            menuPublic: null,
            historyToken: "/error-invoices/create",
            children: [],
          },
          {
            id: 41,
            menuName: "Danh sách thông báo hóa đơn sai sót",
            menuCode: "ROLE",
            menuOrder: 20,
            parentId: 34,
            sys: null,
            superAdmin: null,
            urlPropertyName: "ECONTRACT",
            moduleName: "home",
            menuType: null,
            menuPublic: null,
            historyToken: "/error-invoices",
            children: [],
          },
          {
            id: 41,
            menuName: "Danh sách hóa đơn sai sót",
            menuCode: "ROLE",
            menuOrder: 20,
            parentId: 34,
            sys: null,
            superAdmin: null,
            urlPropertyName: "ECONTRACT",
            moduleName: "home",
            menuType: null,
            menuPublic: null,
            historyToken: "/error-invoices/invoices",
            children: [],
          },
        ],
      },
      {
        id: 40,
        menuName: "Hóa đơn khác",
        menuCode: MENU_CODE.ISSUE_SALES_INVOICE.code,
        menuOrder: 10,
        parentId: null,
        sys: null,
        superAdmin: null,
        urlPropertyName: null,
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: null,
        children: [
          //   {
          //     id: 41,
          //     menuName: "Tem phiếu",
          //     menuCode: "ROLE",
          //     menuOrder: 20,
          //     parentId: 34,
          //     sys: null,
          //     superAdmin: null,
          //     urlPropertyName: "ECONTRACT",
          //     moduleName: "home",
          //     menuType: null,
          //     menuPublic: null,
          //     historyToken: "/issue-invoice-tickets",
          //     children: [],
          //   },
          {
            id: 41,
            menuName: "Phiếu xuất kho kiêm vc nội bộ",
            menuCode: "ROLE",
            menuOrder: 20,
            parentId: 34,
            sys: null,
            superAdmin: null,
            urlPropertyName: "ECONTRACT",
            moduleName: "home",
            menuType: null,
            menuPublic: null,
            historyToken: "/invoice-warehouses",
            children: [],
          },
          {
            id: 41,
            menuName: "Phiếu xuất kho gửi bán đại lý",
            menuCode: "ROLE",
            menuOrder: 20,
            parentId: 34,
            sys: null,
            superAdmin: null,
            urlPropertyName: "ECONTRACT",
            moduleName: "home",
            menuType: null,
            menuPublic: null,
            historyToken: "/invoice-warehouses-agency",
            children: [],
          },
          {
            id: 41,
            menuName: "Phiếu xuất kho kiêm vc nội bộ đã xuất",
            menuCode: "ROLE",
            menuOrder: 20,
            parentId: 34,
            sys: null,
            superAdmin: null,
            urlPropertyName: "ECONTRACT",
            moduleName: "home",
            menuType: null,
            menuPublic: null,
            historyToken: "/invoice-warehouses/report",
            children: [],
          },
          {
            id: 41,
            menuName: "Phiếu xuất kho gửi bán đại lý đã xuất",
            menuCode: "ROLE",
            menuOrder: 20,
            parentId: 34,
            sys: null,
            superAdmin: null,
            urlPropertyName: "ECONTRACT",
            moduleName: "home",
            menuType: null,
            menuPublic: null,
            historyToken: "/invoice-warehouses-agency/report",
            children: [],
          },
          {
            id: 41,
            menuName: "Danh sách hóa đơn tổng",
            menuCode: "ROLE",
            menuOrder: 20,
            parentId: 34,
            sys: null,
            superAdmin: null,
            urlPropertyName: "ECONTRACT",
            moduleName: "home",
            menuType: null,
            menuPublic: null,
            historyToken: "/invoice-total",
            children: [],
          },
          // {
          //   id: 41,
          //   menuName: "Phát hành hóa đơn theo lô",
          //   menuCode: "ROLE",
          //   menuOrder: 20,
          //   parentId: 34,
          //   sys: null,
          //   superAdmin: null,
          //   urlPropertyName: "ECONTRACT",
          //   moduleName: "home",
          //   menuType: null,
          //   menuPublic: null,
          //   historyToken: "/invoice-campaign",
          //   children: [],
          // },
          {
            id: 41,
            menuName: "Hóa đơn treo / lỗi truyền nhận",
            menuCode: "ROLE",
            menuOrder: 20,
            parentId: 34,
            sys: null,
            superAdmin: null,
            urlPropertyName: "ECONTRACT",
            moduleName: "home",
            menuType: null,
            menuPublic: null,
            historyToken: "/invoice-error-tct",
            children: [],
            roleAccess: [
              ROLE_ADMIN,
              ROLE_APP_ADMIN,
              ROLE_SUPERVISOR,
              ROLE_ACCOUNTANT,
              ROLE_EINVOICE_ADMIN,
            ],
          },
        ],
      },
      {
        id: 34,
        menuName: "Báo cáo",
        menuCode: MENU_CODE.REPORT.code,
        menuOrder: 10,
        parentId: null,
        sys: null,
        superAdmin: null,
        urlPropertyName: null,
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "",
        children: [
          // {
          //   id: 35,
          //   menuName: "Bảng tổng hợp dữ liệu Hóa Đơn",
          //   menuCode: "ROLE",
          //   menuOrder: 20,
          //   parentId: 34,
          //   sys: null,
          //   superAdmin: null,
          //   urlPropertyName: "ECONTRACT",
          //   moduleName: "home",
          //   menuType: null,
          //   menuPublic: null,
          //   historyToken: "/report/list-invoice-cycles",
          //   children: [],
          // },
          {
            id: 35,
            menuName: "Bảng kê dữ liệu Hóa đơn / Phiếu xuất kho",
            menuCode: "ROLE",
            menuOrder: 20,
            parentId: 34,
            sys: null,
            superAdmin: null,
            urlPropertyName: "ECONTRACT",
            moduleName: "home",
            menuType: null,
            menuPublic: null,
            historyToken: "/report/list-report-invoice",
            children: [],
          },
          {
            id: 35,
            menuName: "Bảng kê tình hình sử dụng Hóa đơn / Phiếu xuất kho",
            menuCode: "ROLE",
            menuOrder: 20,
            parentId: 34,
            sys: null,
            superAdmin: null,
            urlPropertyName: "ECONTRACT",
            moduleName: "home",
            menuType: null,
            menuPublic: null,
            historyToken: "/report/list-report-invoice-use",
            children: [],
          },
          {
            id: 35,
            menuName: "Báo cáo đối soát truyền nhận hóa đơn",
            menuCode: "ROLE",
            menuOrder: 20,
            parentId: 34,
            sys: null,
            superAdmin: null,
            urlPropertyName: "ECONTRACT",
            moduleName: "home",
            menuType: null,
            menuPublic: null,
            historyToken: "/report/list-report-invoice-transfer",
            children: [],
          },
          // {
          //   id: 35,
          //   menuName: "Báo cáo hóa đơn bị từ chối trong ngày",
          //   menuCode: "ROLE",
          //   menuOrder: 20,
          //   parentId: 34,
          //   sys: null,
          //   superAdmin: null,
          //   urlPropertyName: "ECONTRACT",
          //   moduleName: "home",
          //   menuType: null,
          //   menuPublic: null,
          //   historyToken: "/report/list-report-invoice-rejected-inday",
          //   children: [],
          // },
          // {
          //   id: 35,
          //   menuName: "Bảng kê hóa đơn tổng",
          //   menuCode: "ROLE",
          //   menuOrder: 20,
          //   parentId: 34,
          //   sys: null,
          //   superAdmin: null,
          //   urlPropertyName: "ECONTRACT",
          //   moduleName: "home",
          //   menuType: null,
          //   menuPublic: null,
          //   historyToken: "/report/list-report-invoice-total",
          //   children: [],
          // },
          {
            id: 35,
            menuName: "Bảng tổng hợp hóa đơn sai sót 04/SS-HĐĐT",
            menuCode: "ROLE",
            menuOrder: 20,
            parentId: 34,
            sys: null,
            superAdmin: null,
            urlPropertyName: "ECONTRACT",
            moduleName: "home",
            menuType: null,
            menuPublic: null,
            historyToken: "/report/list-report-invoice-error",
            children: [],
          },
          {
            id: 36,
            menuName: "Bảng kê tổng hợp PDF/ XML",
            menuCode: "ROLE",
            menuOrder: 20,
            parentId: 34,
            sys: null,
            superAdmin: null,
            urlPropertyName: "ECONTRACT",
            moduleName: "home",
            menuType: null,
            menuPublic: null,
            historyToken: "/report/list-zip-file",
            children: [],
          },
        ],
      },
    ],
    // roleAccess: [ROLE_EINVOICE_TAX_DEDUCT],
  },

  //   {
  //     id: 34,
  //     menuName: "Hóa đơn GTGT",
  //     menuCode: MENU_CODE.ISSUE_VAT_INVOICE.code,
  //     menuOrder: 10,
  //     parentId: null,
  //     sys: null,
  //     superAdmin: null,
  //     urlPropertyName: null,
  //     moduleName: "home",
  //     menuType: null,
  //     menuPublic: null,
  //     historyToken: null,
  //     children: [
  //       {
  //         id: 35,
  //         menuName: "HĐ GTGT có mã",
  //         menuCode: "ROLE",
  //         menuOrder: 20,
  //         parentId: 34,
  //         sys: null,
  //         superAdmin: null,
  //         urlPropertyName: "ECONTRACT",
  //         moduleName: "home",
  //         menuType: null,
  //         menuPublic: null,
  //         historyToken: "/issue-vat-invoice/have-code",
  //         children: [],
  //       },
  //       {
  //         id: 35,
  //         menuName: "HĐ GTGT không mã",
  //         menuCode: "ROLE",
  //         menuOrder: 20,
  //         parentId: 34,
  //         sys: null,
  //         superAdmin: null,
  //         urlPropertyName: "ECONTRACT",
  //         moduleName: "home",
  //         menuType: null,
  //         menuPublic: null,
  //         historyToken: "/issue-vat-invoice/none-code",
  //         children: [],
  //       },
  //     ],
  //   },
  //   {
  //     id: 34,
  //     menuName: "Hóa đơn BH",
  //     menuCode: MENU_CODE.ISSUE_SALES_INVOICE.code,
  //     menuOrder: 10,
  //     parentId: null,
  //     sys: null,
  //     superAdmin: null,
  //     urlPropertyName: null,
  //     moduleName: "home",
  //     menuType: null,
  //     menuPublic: null,
  //     historyToken: null,
  //     children: [
  //       {
  //         id: 35,
  //         menuName: "HĐ BH có mã",
  //         menuCode: "ROLE",
  //         menuOrder: 20,
  //         parentId: 34,
  //         sys: null,
  //         superAdmin: null,
  //         urlPropertyName: "ECONTRACT",
  //         moduleName: "home",
  //         menuType: null,
  //         menuPublic: null,
  //         historyToken: "/issue-sales-invoice/have-code",
  //         children: [],
  //       },
  //       {
  //         id: 35,
  //         menuName: "HĐ BH không mã",
  //         menuCode: "ROLE",
  //         menuOrder: 20,
  //         parentId: 34,
  //         sys: null,
  //         superAdmin: null,
  //         urlPropertyName: "ECONTRACT",
  //         moduleName: "home",
  //         menuType: null,
  //         menuPublic: null,
  //         historyToken: "/issue-sales-invoice/none-code",
  //         children: [],
  //       },
  //     ],
  //   },
  {
    id: 434,
    menuName: "Thuế TNCN",
    menuCode: MENU_CODE.PERSONAL_INCOME_TAX_SERVICE.code,
    menuOrder: 10,
    parentId: null,
    sys: null,
    superAdmin: null,
    urlPropertyName: null,
    moduleName: "home",
    menuType: null,
    menuPublic: null,
    historyToken: null,
    children: [
      {
        id: 35,
        menuName: "Lập chứng từ",
        menuCode: "ROLE",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/tax-deduct/list/?create=true",
        children: [],
      },
      {
        id: 35,
        menuName: "Tải lên theo đợt",
        menuCode: "ROLE",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/tax-deduct/batch",
        children: [],
      },
      {
        id: 35,
        menuName: "Danh sách chứng từ",
        menuCode: "ROLE",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/tax-deduct/list",
        children: [],
      },
      {
        id: 35,
        menuName: "Thay thế",
        menuCode: "ROLE",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/tax-deduct/replace",
        children: [],
      },
      {
        id: 35,
        menuName: "Điều chỉnh",
        menuCode: "ROLE",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/tax-deduct/adjust",
        children: [],
      },
      {
        id: 35,
        menuName: "Chứng từ đã xuất",
        menuCode: "ROLE",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/tax-deduct/report",
        children: [],
      },
      // {
      //   id: 35,
      //   menuName: "Báo cáo / Bảng kê",
      //   menuCode: "ROLE",
      //   menuOrder: 20,
      //   parentId: 34,
      //   sys: null,
      //   superAdmin: null,
      //   urlPropertyName: "ECONTRACT",
      //   moduleName: "home",
      //   menuType: null,
      //   menuPublic: null,
      //   roleAccess: [ROLE_EINVOICE_KE_TOAN],
      //   children: [
      //     {
      //       id: 35,
      //       menuName: "Báo cáo chi tiết",
      //       menuCode: "ROLE",
      //       menuOrder: 20,
      //       parentId: 34,
      //       sys: null,
      //       superAdmin: null,
      //       urlPropertyName: "ECONTRACT",
      //       moduleName: "home",
      //       menuType: null,
      //       menuPublic: null,
      //       historyToken: "/tax-deduct/report-tax-deduct-use",
      //       children: [],
      //     },
      //     {
      //       id: 35,
      //       menuName: "Bảng kê tình hình sử dụng",
      //       menuCode: "ROLE",
      //       menuOrder: 20,
      //       parentId: 34,
      //       sys: null,
      //       superAdmin: null,
      //       urlPropertyName: "ECONTRACT",
      //       moduleName: "home",
      //       menuType: null,
      //       menuPublic: null,
      //       historyToken: "/tax-deduct/report-portal",
      //       children: [],
      //     },
      //   ],
      // },
    ],
    // roleAccess: [ROLE_EINVOICE_TAX_DEDUCT],
  },
  {
    id: 434,
    menuName: "Nghiệp vụ Thuế TNCN",
    menuCode: MENU_CODE.TAX_DEDUCT_SERVICE.code,
    menuOrder: 10,
    parentId: null,
    sys: null,
    superAdmin: null,
    urlPropertyName: null,
    moduleName: "home",
    menuType: null,
    menuPublic: null,
    historyToken: null,
    children: [
      {
        id: 35,
        menuName: "Chứng từ sai sót (Thông báo sai sót cho chứng từ)",
        menuCode: "ROLE",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        children: [
          {
            id: 35,
            menuName: "Lập thông báo chứng từ sai sót",
            menuCode: "ROLE",
            menuOrder: 20,
            parentId: 34,
            sys: null,
            superAdmin: null,
            urlPropertyName: "ECONTRACT",
            moduleName: "home",
            menuType: null,
            menuPublic: null,
            historyToken: "/error-tax-deducts/create",
            children: [],
          },
          {
            id: 35,
            menuName: "Danh sách chứng từ sai sót",
            menuCode: "ROLE",
            menuOrder: 20,
            parentId: 34,
            sys: null,
            superAdmin: null,
            urlPropertyName: "ECONTRACT",
            moduleName: "home",
            menuType: null,
            menuPublic: null,
            historyToken: "/error-tax-deducts",
            children: [],
          },
        ],
      },
      {
        id: 34,
        menuName: "Báo cáo",
        menuCode: MENU_CODE.REPORT.code,
        menuOrder: 10,
        parentId: null,
        sys: null,
        superAdmin: null,
        urlPropertyName: null,
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "",
        children: [
          {
            id: 35,
            menuName: "Bảng kê sử dụng chứng từ khấu trừ thuế thu nhập cá nhân",
            menuCode: "ROLE",
            menuOrder: 20,
            parentId: 34,
            sys: null,
            superAdmin: null,
            urlPropertyName: "ECONTRACT",
            moduleName: "home",
            menuType: null,
            menuPublic: null,
            historyToken: "/tax-deduct/list-report-use",
            children: [],
          },
          {
            id: 35,
            menuName: "Báo cáo đối soát truyền nhận chứng từ",
            menuCode: "ROLE",
            menuOrder: 20,
            parentId: 34,
            sys: null,
            superAdmin: null,
            urlPropertyName: "ECONTRACT",
            moduleName: "home",
            menuType: null,
            menuPublic: null,
            historyToken: "/tax-deduct/list-report-transfer",
            children: [],
          },
        ],
      },
    ],
    // roleAccess: [ROLE_EINVOICE_TAX_DEDUCT],
  },

  {
    id: 34,
    menuName: "Tờ khai",
    menuCode: MENU_CODE.DATA_FORMAT.code,
    menuOrder: 10,
    parentId: null,
    sys: null,
    superAdmin: null,
    urlPropertyName: null,
    moduleName: "home",
    menuType: null,
    menuPublic: null,
    historyToken: "",
    children: [
      {
        menuName: "Tờ khai đăng ký/thay đổi thông tin sử dụng HĐĐT",
        menuCode: MENU_CODE.DATA_FORMAT.code,
        menuOrder: 10,
        parentId: null,
        sys: null,
        superAdmin: null,
        urlPropertyName: null,
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/data-format/registry-invoice",
        children: [],
      },
      {
        id: 35,
        menuName: "Tờ khai đăng ký/thay đổi thông tin sử dụng CTĐT",
        menuCode: "MENU_REGISTER_TAX_DEDUCT",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/tax-deduct/register",
        children: [],
        // roleAccess: [ROLE_EINVOICE_KE_TOAN],
      },
      //   {
      //     id: 35,
      //     menuName: "Ủy quyền lập hóa đơn",
      //     menuCode: "ROLE",
      //     menuOrder: 20,
      //     parentId: 34,
      //     sys: null,
      //     superAdmin: null,
      //     urlPropertyName: "ECONTRACT",
      //     moduleName: "home",
      //     menuType: null,
      //     menuPublic: null,
      //     historyToken: "/data-format/registry-delegate",
      //     children: [],
      //   },
      //   {
      //     id: 35,
      //     menuName: "Đề nghị cấp HDDT có mã",
      //     menuCode: "ROLE",
      //     menuOrder: 20,
      //     parentId: 34,
      //     sys: null,
      //     superAdmin: null,
      //     urlPropertyName: "ECONTRACT",
      //     moduleName: "home",
      //     menuType: null,
      //     menuPublic: null,
      //     historyToken: "/data-format/request-invoice-code",
      //     children: [],
      //   },
    ],
  },

  {
    id: 34,
    menuName: "Danh mục",
    menuCode: MENU_CODE.GENERAL_INFORMATIONS.code,
    menuOrder: 10,
    parentId: null,
    sys: null,
    superAdmin: null,
    urlPropertyName: null,
    moduleName: "home",
    menuType: null,
    menuPublic: null,
    historyToken: null,
    children: [
      {
        id: 35,
        menuName: "Danh sách đơn vị kinh doanh",
        menuCode: "ROLE",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/business-unit-manager/list",
        children: [],
      },
      {
        id: 36,
        menuName: "Danh sách tiền tệ",
        menuCode: "USER_ROLE",
        menuOrder: 30,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/currency-manager/list",
        children: [],
      },
      {
        id: 36,
        menuName: "Danh sách VAT",
        menuCode: "USER_ROLE",
        menuOrder: 30,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/vat-manager/list",
        children: [],
      },
      {
        id: 36,
        menuName: "Danh sách phương thức thanh toán",
        menuCode: "USER_ROLE",
        menuOrder: 30,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/payment-method-manager/list",
        children: [],
      },
      {
        id: 36,
        menuName: "Danh sách ký hiệu hóa đơn",
        menuCode: "USER_ROLE",
        menuOrder: 30,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/invoice-symbol-manager/list",
        children: [],
      },
      {
        id: 36,
        menuName: "Danh sách Sign Method",
        menuCode: "SIGN_METHOD",
        menuOrder: 30,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/sign-method/list",
        children: [],
      },
      {
        id: 36,
        menuName: "Danh sách sản phẩm/ dịch vụ",
        menuCode: "USER_ROLE",
        menuOrder: 30,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/product/list",
        children: [],
      },
      {
        id: 36,
        menuName: "Danh sách khách hàng",
        menuCode: "USER_ROLE",
        menuOrder: 30,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/customer/list",
        children: [],
      },
      {
        id: 36,
        menuName: "Danh sách User",
        menuCode: "USER_ROLE",
        menuOrder: 30,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/user/list",
        children: [],
      },
      //   {
      //     id: 36,
      //     menuName: "Mẫu email doanh nghiệp",
      //     menuCode: "USER_ROLE",
      //     menuOrder: 30,
      //     parentId: 34,
      //     sys: null,
      //     superAdmin: null,
      //     urlPropertyName: "ECONTRACT",
      //     moduleName: "home",
      //     menuType: null,
      //     menuPublic: null,
      //     historyToken: "/business-email-templates",
      //     children: [],
      //   },
      //   {
      //     id: 36,
      //     menuName: "Danh sách hóa đơn mẫu",
      //     menuCode: "USER_ROLE",
      //     menuOrder: 30,
      //     parentId: 34,
      //     sys: null,
      //     superAdmin: null,
      //     urlPropertyName: "ECONTRACT",
      //     moduleName: "home",
      //     menuType: null,
      //     menuPublic: null,
      //     historyToken: "/invoice-templates",
      //     children: [],
      //   },
    ],
  },
];

const menuHDMTT = {
  id: 343,
  menuName: "Hóa đơn từ MTT",
  menuCode: MENU_CODE.INVOICE_POS.code,
  menuOrder: 10,
  parentId: null,
  sys: null,
  superAdmin: null,
  urlPropertyName: null,
  moduleName: "home",
  menuType: null,
  menuPublic: null,
  historyToken: null,
  children: [
    {
      id: 35,
      menuName: "Lập hóa đơn",
      menuCode: "ROLE",
      menuOrder: 20,
      parentId: 34,
      sys: null,
      superAdmin: null,
      urlPropertyName: "ECONTRACT",
      moduleName: "home",
      menuType: null,
      menuPublic: null,
      historyToken: "/invoice-pos/create?is-pos=true",
      children: [],
    },
    {
      id: 35,
      menuName: "Lưu tạm",
      menuCode: "ROLE",
      menuOrder: 20,
      parentId: 34,
      sys: null,
      superAdmin: null,
      urlPropertyName: "ECONTRACT",
      moduleName: "home",
      menuType: null,
      menuPublic: null,
      historyToken: "/invoice-pos/new",
      children: [],
    },
    {
      id: 35,
      menuName: "Đã phát hành",
      menuCode: "ROLE",
      menuOrder: 20,
      parentId: 34,
      sys: null,
      superAdmin: null,
      urlPropertyName: "ECONTRACT",
      moduleName: "home",
      menuType: null,
      menuPublic: null,
      historyToken: "/invoice-pos/release",
      children: [],
    },
    {
      id: 35,
      menuName: "Chờ phát hành",
      menuCode: "ROLE",
      menuOrder: 20,
      parentId: 34,
      sys: null,
      superAdmin: null,
      urlPropertyName: "ECONTRACT",
      moduleName: "home",
      menuType: null,
      menuPublic: null,
      historyToken: "/invoice-pos/wait-release",
      children: [],
    },
    {
      id: 35,
      menuName: "Hủy",
      menuCode: "ROLE",
      menuOrder: 20,
      parentId: 34,
      sys: null,
      superAdmin: null,
      urlPropertyName: "ECONTRACT",
      moduleName: "home",
      menuType: null,
      menuPublic: null,
      historyToken: "/invoice-pos/cancel",
      children: [],
    },
    {
      id: 35,
      menuName: "Thuế từ chối duyệt",
      menuCode: "ROLE",
      menuOrder: 20,
      parentId: 34,
      sys: null,
      superAdmin: null,
      urlPropertyName: "ECONTRACT",
      moduleName: "home",
      menuType: null,
      menuPublic: null,
      historyToken: "/invoice-pos/tax-refused-approval",
      children: [],
    },
    {
      id: 35,
      menuName: "Thay thế",
      menuCode: "ROLE",
      menuOrder: 20,
      parentId: 34,
      sys: null,
      superAdmin: null,
      urlPropertyName: "ECONTRACT",
      moduleName: "home",
      menuType: null,
      menuPublic: null,
      historyToken: "/invoice-pos/replace",
      children: [],
    },
    {
      id: 35,
      menuName: "Điều chỉnh",
      menuCode: "ROLE",
      menuOrder: 20,
      parentId: 34,
      sys: null,
      superAdmin: null,
      urlPropertyName: "ECONTRACT",
      moduleName: "home",
      menuType: null,
      menuPublic: null,
      historyToken: "/invoice-pos/adjust",
      children: [],
    },
    {
      id: 35,
      menuName: "Tất cả",
      menuCode: "ROLE",
      menuOrder: 20,
      parentId: 34,
      sys: null,
      superAdmin: null,
      urlPropertyName: "ECONTRACT",
      moduleName: "home",
      menuType: null,
      menuPublic: null,
      historyToken: "/invoice-pos/all",
      children: [],
    },
    {
      id: 35,
      menuName: "Đợt gửi hóa đơn",
      menuCode: "ROLE",
      menuOrder: 20,
      parentId: 34,
      sys: null,
      superAdmin: null,
      urlPropertyName: "ECONTRACT",
      moduleName: "home",
      menuType: null,
      menuPublic: null,
      historyToken: "/invoice-pos/phase",
      children: [],
    },
    {
      id: 35,
      menuName: "Hóa đơn đã xuất",
      menuCode: "ROLE",
      menuOrder: 20,
      parentId: 34,
      sys: null,
      superAdmin: null,
      urlPropertyName: "ECONTRACT",
      moduleName: "home",
      menuType: null,
      menuPublic: null,
      historyToken: "/invoice-pos/report",
      children: [],
    },
  ],
};

const ConfigMenu = props => {
  const { t, i18n } = useTranslation();

  const Dashboard = useSelector(state => state.Dashboard);
  const {
    buTenantHeaderInfo,
    finalBuInfo,
    buStoreHeader,
    tenantCodeHeader,
    listBuOfTenant,
  } = Dashboard;

  // const { menuArr } = props;
  const [menuOpen, setMenuOpen] = useState({});
  const [subChildrenItemMenuOpen, setSubChildrenItemMenuOpen] = useState({});
  const [menyLoad, setMenuLoad] = useState([]);
  const [roles, setRoles] = useState([]);

  const toggleMenu = key => {
    setMenuOpen(prevMenuOpen => ({
      //   ...prevMenuOpen,
      [key]: !prevMenuOpen[key],
    }));
  };

  const toggleSubChildrenItemMenu = key => {
    setSubChildrenItemMenuOpen(prevSubChildrenItemMenuOpen => ({
      ...prevSubChildrenItemMenuOpen,
      [key]: !prevSubChildrenItemMenuOpen[key],
    }));
  };

  // Action Dispatch
  useEffect(() => {
    const info = localStorage.getItem(AUTH_TOKEN)
      ? jwt_decode(localStorage.getItem(AUTH_TOKEN))
      : null;
    const roleUser = info?.["auth"];
    if (roleUser) {
      const listRole = info["auth"].split(",");
      setRoles(listRole);
    }
  }, []);

  useEffect(() => {
    let finalMenu = [...menu];
    // Check config dc hiện MTT
    if (
      checkIsHaveInvoicePos(
        buTenantHeaderInfo,
        finalBuInfo,
        buStoreHeader,
        tenantCodeHeader,
        listBuOfTenant
      )
    ) {
      if (!finalMenu.find(f => f.menuCode === MENU_CODE.INVOICE_POS.code)) {
        finalMenu.splice(1, 0, menuHDMTT);
      }
    }
    console.log("Menu hiển thị", finalMenu);
    setMenuLoad(finalMenu);
  }, [
    buTenantHeaderInfo,
    finalBuInfo,
    buStoreHeader,
    tenantCodeHeader,
    listBuOfTenant,
  ]);

  return (
    <React.Fragment>
      {menyLoad.map((childItem, index) => {
        return (
          <React.Fragment key={index}>
            <li key={index} className="nav-item dropdown">
              <Link
                className="nav-link dropdown-toggle arrow-none d-flex align-items-center"
                onClick={e => {
                  if (childItem.children.length > 0) {
                    e.preventDefault();
                    toggleMenu(index);
                  } else {
                    setMenuOpen({});
                  }
                }}
                to={childItem.historyToken ? childItem.historyToken : "/#"}
              >
                <i
                  className={returnImgByMenuCode(childItem.menuCode) + " me-2"}
                ></i>
                {childItem.menuName} {props.menuOpen}
                {childItem.children.length > 0 && (
                  <div className="arrow-down"></div>
                )}
              </Link>
              {childItem.children.length > 0 && (
                <div
                  className={classname("dropdown-menu", {
                    show: menuOpen[index],
                  })}
                >
                  {childItem.children.map((child, childIndex) => {
                    let dataHref = "";
                    if (child.moreToken) {
                      dataHref = child.moreToken.join("___");
                    }
                    if (
                      !child.roleAccess ||
                      (child.roleAccess &&
                        roles.filter(arr1Item =>
                          child.roleAccess.includes(arr1Item)
                        ).length > 0)
                    ) {
                      return child?.children?.length === 0 ? (
                        <Link
                          key={childIndex}
                          className="dropdown-item"
                          to={`${child.historyToken}`}
                          // to={
                          //   `${prefixPath}` +
                          //   child?.historyToken?.split("_")?.join("-")
                          // }
                          datahref={dataHref}
                          onClick={() => toggleMenu(false)}
                        >
                          <div
                            style={{
                              marginLeft: "5px",
                            }}
                          >
                            {child.menuName}
                          </div>
                        </Link>
                      ) : (
                        <div key={childIndex} className="custom_menu">
                          <nav className="menu">
                            <li className="dropdown-item show-submenu">
                              <ul className="submenu">
                                {child?.children
                                  ?.sort((a, b) => a?.menuOrder - b?.menuOrder)
                                  .map((subItem, subItemIndex) => {
                                    return (
                                      <li key={subItemIndex}>
                                        <Link
                                          className="dropdown-item"
                                          to={`${subItem.historyToken}`}
                                          // to={
                                          //   `${prefixPath}` +
                                          //   subItem.historyToken
                                          //     .split("_")
                                          //     .join("-")
                                          // }
                                          datahref={dataHref}
                                          onClick={() => toggleMenu(false)}
                                        >
                                          <div
                                            style={{
                                              marginLeft: "5px",
                                            }}
                                          >
                                            {subItem.menuName}
                                          </div>
                                        </Link>
                                      </li>
                                    );
                                  })}
                              </ul>

                              <span
                                style={{
                                  marginLeft: "5px",
                                }}
                                onClick={e => {
                                  if (child.children?.length > 0) {
                                    e.preventDefault();
                                    if (window.innerWidth < 991) {
                                      toggleSubChildrenItemMenu(childIndex);
                                    }
                                  }
                                }}
                              >
                                {child.menuName}
                              </span>
                              <div className="arrow-down"></div>

                              {/* MOBILE MENU START */}
                              {child.children?.length > 0 && (
                                <div
                                  className={classname("dropdown-menu", {
                                    show: subChildrenItemMenuOpen[childIndex],
                                  })}
                                >
                                  {Array.isArray(child?.children) &&
                                    child.children.map(
                                      (menuMobileItem, menuMobileItemIndex) => {
                                        return (
                                          <Link
                                            key={menuMobileItemIndex}
                                            to={
                                              menuMobileItem?.historyToken ||
                                              "#"
                                            }
                                            style={{
                                              backgroundColor: "transparent",
                                              color: "black",
                                            }}
                                            onClick={() => toggleMenu(false)}
                                          >
                                            {menuMobileItem.menuName}
                                          </Link>
                                        );
                                      }
                                    )}
                                </div>
                              )}
                              {/* MOBILE MENU E N D */}
                            </li>
                          </nav>
                        </div>
                      );
                    } else {
                      return <React.Fragment key={childIndex}></React.Fragment>;
                    }
                  })}
                </div>
              )}
            </li>
          </React.Fragment>
        );
      })}
    </React.Fragment>
  );
};

ConfigMenu.propTypes = {
  lang: PropTypes.object,
  menuArr: PropTypes.any,
  menuOpen: PropTypes.any,
};

export default withRouter(ConfigMenu);
